import WorkArt1 from "@resources/competition/kuso-mural-final-1.jpg?format=webp&quality=80&imagetools";
import WorkArt2 from "@resources/competition/kuso-mural-final-2.jpg?format=webp&quality=80&imagetools";
import WorkArt3 from "@resources/competition/kuso-mural-final-3.jpg?format=webp&quality=80&imagetools";

import FsLightbox from "fslightbox-react";
import { useState } from "react";

export const RendersOfWorkArts = () => {
    const IMAGES = [WorkArt1, WorkArt2, WorkArt3];

    const LIGHTBOX_IMAGES = IMAGES.map((src, i) => (
        <img
            key={i}
            src={src}
            alt={`Praca ${i + 1}`}
            width={1920}
            height={1080}
            className="w-full h-auto object-contain"
        />
    ));

    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1,
    });

    const openLightboxOnSlide = (index: number) => {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: index + 1,
        });
    };

    const hideHeader = () => {
        document
            .querySelector(".sticky.top-0.z-50.w-full")
            ?.classList.add("hidden");
    };

    const showHeader = () => {
        document
            .querySelector(".sticky.top-0.z-50.w-full")
            ?.classList.remove("hidden");
    };

    return (
        <section className="py-20 lg:px-20 px-4">
            <h2 className="text-center lg:mb-14 mb-8 text-h3 text-primary font-black uppercase">
                Galeria
            </h2>
            <div className="grid lg:grid-cols-3 grid-cols-1 gap-x-3 gap-y-8">
                {IMAGES.map((image, index) => (
                    <img
                        key={index}
                        src={image}
                        alt={`Praca ${index + 1}`}
                        className="cursor-pointer w-full h-auto object-cover"
                        onClick={() => openLightboxOnSlide(index)}
                    />
                ))}
            </div>

            <FsLightbox
                toggler={lightboxController.toggler}
                sources={LIGHTBOX_IMAGES}
                slide={lightboxController.slide}
                onShow={hideHeader}
                onInit={hideHeader}
                onClose={showHeader}
            />
        </section>
    );
};
